module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/th/3-0abf7fed885aec4c391895f63f40f7e5.jpg";